import moment from 'moment';
import * as yup from 'yup';
import { array, string } from 'yup';

import { i18nt } from '../../../../../../../root';
import { NSPP_TRAVEL, NSPP_VALIDATION } from '../../../../../../../services/i18n/namespaces';
import {
  travelServiceTypes,
  travelStatuses,
  travelTimeList
} from '../../EncountersSection/TravelSection/travelConstants';

const addressSchema = yup.object({
  type: yup.string().required(i18nt(`${NSPP_VALIDATION}:addressTypeIsRequired`)),
  countryId: yup.string().required(i18nt(`${NSPP_VALIDATION}:countryIsRequired`)),
  regionId: yup.string().required(i18nt(`${NSPP_VALIDATION}:isRequired`)),
  city: yup.string().required(i18nt(`${NSPP_VALIDATION}:cityIsRequired`)),
  address1: yup.string().required(i18nt(`${NSPP_VALIDATION}:address1IsRequired`)),
  address2: yup.string().notRequired(),
  zipCode: yup.string().required(i18nt(`${NSPP_VALIDATION}:zipCodeIsRequired`))
});

export const validationSchema = yup.object({
  status: yup
    .string()
    .oneOf(travelStatuses.map(({ id }) => id))
    .required(i18nt(`${NSPP_TRAVEL}:validation.fieldIsRequired`)),
  visitDate: yup
    .date()
    .typeError(i18nt(`${NSPP_VALIDATION}:invalidDate`))
    .min(moment().startOf('day'), i18nt(`${NSPP_TRAVEL}:validation.visitDateCantBeInThePast`))
    .required(i18nt(`${NSPP_TRAVEL}:validation.fieldIsRequired`)),
  visitStartTime: yup
    .date()
    .typeError(i18nt(`${NSPP_TRAVEL}:validation.invalidTime`))
    .required(i18nt(`${NSPP_TRAVEL}:validation.fieldIsRequired`)),
  visitEndTime: yup
    .date()
    .typeError(i18nt(`${NSPP_TRAVEL}:validation.invalidTime`))
    .notRequired()
    .when('visitStartTime', {
      is(value) {
        return !!value;
      },
      then: schema => {
        return schema.min(yup.ref('visitStartTime'), i18nt(`${NSPP_TRAVEL}:validation.endTimeCantBeBeforeStartTime`));
      },
      otherwise: schema => {
        return schema;
      }
    }),
  requestedServices: array()
    .of(string().oneOf(travelServiceTypes.map(({ id }) => id)))
    .min(1, i18nt(`${NSPP_TRAVEL}:validation.selectAtLeastOneService`)),

  departureDate: yup
    .date()
    .typeError(i18nt(`${NSPP_VALIDATION}:invalidDate`))
    .notRequired(),
  returnDate: yup
    .date()
    .typeError(i18nt(`${NSPP_VALIDATION}:invalidDate`))
    .notRequired()
    .when('departureDate', {
      is(value) {
        return !!value;
      },
      then: schema => {
        return schema.min(
          yup.ref('departureDate'),
          i18nt(`${NSPP_TRAVEL}:validation.returnDateCantBeBeforeDepartureDate`)
        );
      },
      otherwise: schema => {
        return schema;
      }
    }),
  preferredDepartureAirport: yup.string().notRequired(),
  preferredTravelTime: array()
    .of(string().oneOf(travelTimeList.map(({ id }) => id)))
    .notRequired(),

  pickupAddress: addressSchema,
  pickupAddressComments: yup.string(i18nt(`${NSPP_TRAVEL}:validation.enterComments`)).notRequired(),

  dropOffAddress: addressSchema,
  dropOffAddressComments: yup.string(i18nt(`${NSPP_TRAVEL}:validation.enterComments`)).notRequired(),

  comments: yup.string(i18nt(`${NSPP_TRAVEL}:validation.enterComments`)).notRequired()
});
